<template lang="pug">
div
  v-layout.flex-column-phone(align-center, justify-space-between)
    h2 Dealer overzicht

    v-layout.grow-0(align-center)
      v-text-field(
        v-model='search',
        append-icon='fa fa-search',
        label='Zoeken',
        hide-details,
        clearable,
        solo
        )
      v-btn.ml-4.hidden-phone(color='primary', :to='{ name: "website details", params: { websiteId: "new" } }') Dealer toevoegen

  v-layout.mt-3(column)
    v-card.elevation-0
      v-data-table(
        :headers='headers',
        :items='filteredWebsites',
        :expand='true',
        item-key='id',
        :pagination.sync='pagination',
        :loading='loading',
        :must-sort='true',
        :rows-per-page-items='[10, 50]'
        )

        template(slot='items', slot-scope='props')
          tr
            td {{ props.item.dealerInfo.companyName }}
            td {{ props.item.dealerInfo.contactLastName }}
            td {{ props.item.dealerInfo.city }}
            td {{ props.item.domain }}
            td.text-xs-right
              options
                v-list-tile(:to='{ name: "website details", params: { websiteId: props.item.id }, query: { tab: 3 } }')
                  v-icon.mr-2 fa fa-cog
                  | Bewerken
                //- v-list-tile(@click='setWebsiteState(props.item, "disabled")', v-if='props.item.state !== "disabled"')
                  v-icon.mr-2 fa fa-ban
                  | Uitschakelen
                //- v-divider
                //- v-list-tile(@click='deleteLease(props.item)')
                  v-icon.mr-2(color='error') fa fa-trash-alt
                  | Verwijderen
</template>

<script>
export default {
  name: 'Dealers',

  components: {
    Options: require('@/components/Table/Options').default
  },

  data () {
    return {
      websites: [],

      loading: false,
      search: this.$store.state.filters.search,
      headers: [
        {
          text: 'Bedrijfsnaam',
          value: 'domain'
        },
        {
          text: 'Achternaam',
          value: 'contactLastName'
        },
        {
          text: 'Plaats',
          value: 'city'
        },
        {
          text: 'URL',
          value: 'domain'
        },
        {
          text: null,
          sortable: false
        }
      ],

      pagination: {
        sortBy: 'createdAt',
        descending: true
      }
    }
  },

  computed: {
    filteredWebsites () {
      if (!this.search) return this.websites

      return this.websites.filter(w => {
        return Object.values(w).some(x => x && x.toString().toLowerCase().includes(this.search.toLowerCase())) || // search website // Bug: dealerInfo value is an Object which is cast to a string which results in [object Object] so if you search for "object" you will filter nothing
          Object.values(w.dealerInfo).some(x => x && x.toString().toLowerCase().includes(this.search.toLowerCase())) // search dealerInfo
      })
    }
  },

  async created () {
    this.loading = true

    this.websites = await this.$store.dispatch('graphqlQuery', {
      name: 'getWebsitesWithDealerInfo',
      variables: {
        orgId: this.$store.state.organization.currentOrgId
      }
    })

    this.loading = false
  },

  watch: {
    search (v) {
      this.$store.commit('filters/setSearch', v)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
